export const ADD_ARTICLE = "ADD_ARTICLE";
export const SET_FLAGS = "SET_FLAGS";



// WEBPACK FOOTER //
// ./src/redux/constants/action-types.js